import React, { useState } from "react";
import  "./imgInhancerHero.scss";
import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/navigation";

import commingSoon from "@/../public/home/hero/commingSoon.svg";
import imgInhancer01 from "@/../public/home/hero/imgInhancer01.jpg";
import imgInhancer02 from "@/../public/home/hero/imgInhancer02.jpg";
import imgInhancer03 from "@/../public/home/hero/imgInhancer03.jpg";

export default function ImgInhancerHero({
  setDisplayCard,
  setShowCommingSoonModal,
  path
}) {
  const router = useRouter();
  const [imgInhancerIndex, setImgInhancerIndex] = useState(0);
  const [imgInhancerImg, setImgInhancerImg] = useState(imgInhancer01);

  const imageInhancer = [
    {
      img: imgInhancer01,
      name: "single",
    },
    {
      img: imgInhancer02,
      name: "group",
    },
    {
      img: imgInhancer03,
      name: "video",
    },
  ];

  return (
    <div onClick={() => setDisplayCard("enhancer")} className="faceSwap">
      <div
        onClick={() => router.push(`${path}`)}
        className="imgContainer"
      >
        <Image src={imgInhancerImg} alt="face-swap" className="img" />
      </div>
      <div className="faceSwapContent">
        <div className="productTop">
          <div className="titleContainer">
            <p className="title">AI Image Enhancer</p>
            <div className="free1">
              {/* <Image src={commingSoon} alt="face-swap" /> */}
              {/* <p className={styles.freeTxt}>Coming Soon</p> */}
              <p className="freeTxt1">
                <span className="span span1">F</span>
                <span className="span span2">R</span>
                <span className="span span3">E</span>
                <span className="span span4">E</span>
              </p>
            </div>
          </div>
          {/* <p className={styles.description}>
            Make the picture clearer and make the small details really pop so
            that the overall quality is amazing.
          </p> */}
        </div>
        <div className="bottom">
          <div className="swapImg">
            {imageInhancer?.map((item, index) => (
              <div
                className={` ${
                  imgInhancerIndex === index ? "active" : ""
                } imgContainerSwitch`}
                key={index}
              >
                <Image
                  src={item.img}
                  alt={item.name}
                  onClick={() => {
                    setImgInhancerIndex(index);
                    setImgInhancerImg(item.img);
                  }}
                  className="imgSwitch"
                />
              </div>
            ))}
          </div>
          <Link href={`${path}`} className="link">
            <button className="btn1 btn">Try it out</button>
          </Link>
        </div>
      </div>
    </div>
  );
}
